import React, { FC } from 'react';

import { Form } from 'antd';
import { Label, TextArea } from 'ui';
import { formRules } from 'utils/formRules';

import s from './NotifyUserOfOrder.module.scss';

const NotifyUserOfOrder: FC = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Specify email who should be notified. Use a ; to seperate emails</Label>
          <Form.Item name="emailToNotify" rules={[formRules.required]}>
            <TextArea style={{ width: '100%' }} name="emailToNotify" size="middle" />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default NotifyUserOfOrder;
